import { Badge, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';

import ChatWithJob from '../Chat/ChatWithJob';
import ChatWithICP from '../Chat/ChatWithICP';
import { backBtn, whiteInfo } from '../../../assets/images/images';

const ChatWindow = ({
    conversationId,
    step,
    jobId,
    companyName,
    jobTitle,
    jobAction,
    hideChatWindow,
    setHideChatWindow,
    jobNearPeer,
    updatedNearPeer,
    fetchNPRanking,
    refreshJobData,
    handleClose
}: any) => {
    const generateJobDescription = () => {
        console.info('Generate');
    };

    const returnJobNearPeer = () => {
        return ((updatedNearPeer?.near_pear_ranking || jobNearPeer) || '');
    }
    return (
        <>
            <div className="preview-right">
                {step === 'job-description' && (
                    <>
                        <div className={`preview-title d-md-none ${jobAction === 'edit' ? 'mobile-inline-title-row' : ''}`}>
                            {jobAction === 'edit' && (
                                <span
                                    className="back-btn candidate-back"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => handleClose()}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            handleClose();
                                        }
                                    }}
                                >
                                    <Image
                                        src={backBtn}
                                        height={25}
                                        width={25}
                                        alt="Back"
                                        className="back-btn-arrow"
                                    />
                                </span>
                            )}
                            {jobAction !== 'edit' ? jobTitle : 'Edit Job Description'}<span>.</span>
                        </div>
                        {/* hide-on-mobile */}
                        <div className="badge-container d-md-none">
                            <Badge bg="secondary">{companyName}</Badge>
                        </div>
                    </>
                )}
                {step === 'idealize-candidate' && (
                    <>
                        <div className="preview-title d-md-none mobile-inline-title-row">
                            <span
                                className="back-btn candidate-back"
                                role="button"
                                tabIndex={0}
                                onClick={() => handleClose()}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        handleClose();
                                    }
                                }}
                            >
                                <Image
                                    src={backBtn}
                                    height={25}
                                    width={25}
                                    alt="Back"
                                    className="back-btn-arrow"
                                />
                            </span>
                            {jobAction !== 'edit' ? jobTitle : 'Edit Attributes'}<span>.</span>
                        </div>
                        <p className="preview-subtitle d-md-none">
                            Identify the ideal attributes for the candidate.
                        </p>
                    </>
                )}
                {step === 'job-description' && (
                    <div className="box-container">
                        <div className="box bg-primary">
                            <div className="box-title refresh-box-title">
                                <div className='neer-ranking-value'>
                                <Button variant="light" className="ranking-generate-btn" onClick={fetchNPRanking}>
                                    {returnJobNearPeer() ? 'Regenerate Ranking' : 'Generate Ranking'}
                                </Button>
                                {returnJobNearPeer() && (
                                    <>
                                        {returnJobNearPeer()}%
                                    </>
                                )}
                                </div>
                                <div className='refresh-info-title'>
                                <p>Near Peer Ranking</p>
                                <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    Generating the Near Peer results takes upto 30 seconds.
                                                </Tooltip>
                                            }
                                        >

                                            <div className="refresh-info">
                                                <Image src={whiteInfo} height={16} width={16} alt="Info" />
                                            </div>
                                </OverlayTrigger>
                                </div>
                            </div>
                            {/* <p>Near Peer Ranking</p> */}
                            <p className="box-content-p">
                                This score shows how closely your job description compares with similar roles in similar companies. A higher percentage indicates a stronger match with your 'near peers,' giving you clarity on how this aligns with the market.
                            </p>
                        </div>
                        <div className="box second-box d-none">
                            <div className="box-title">80%</div>
                            <p>Comp Rating</p>
                            <p className="box-content-p">
                                Donec a eros justo. Fusce egestas tristique ultrices. Nam
                                tempor, augue nec tincidunt. Donec a eros justo. Fusce egestas
                                tristique ultrices. Fusce egestas tristique ultrices.Fusce
                                egestas tristique ultrices.
                            </p>
                        </div>
                    </div>
                )}
                <div className={`chat-container ${hideChatWindow ? 'chat-job-m-hide' : 'chat-job-container'}`}>
                    <div className="chat-inner job-review-chat-inner">
                        {step === 'job-description' ? (
                            <ChatWithJob
                                conversationId={conversationId}
                                generateJobDescription={generateJobDescription}
                                jobId={jobId}
                                step={step}
                                hideChatWindow={hideChatWindow}
                                setHideChatWindow={setHideChatWindow}
                                refreshJobData={refreshJobData}
                            />
                        ) : (
                            <ChatWithICP
                                conversationId={conversationId}
                                generateJobDescription={generateJobDescription}
                                jobId={jobId}
                                step={step}
                                hideChatWindow={hideChatWindow}
                                setHideChatWindow={setHideChatWindow}
                                refreshJobData={refreshJobData}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChatWindow;
